module.exports = __webpack_public_path__ + "img/Restaurant5.df7167ed.png";